import { onAuthStateChanged, signOut } from 'firebase/auth'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { ToastContainer } from 'react-toastify';
import { auth } from '../firebase'
import Header from './Header'
import './Profile.css'
import { cancelUtility, login, notify } from './utility'
import Footer from './Footer'

function Profile({ server }) {
    const [userData, setUserData] = useState([])
    const [userAuth, setUserAuth] = useState([])
    const [load, setLoad] = useState(false)
    const [trialState, setTrialState] = useState(false)
    const [daysLeft, setDaysLeft] = useState(0)
    const cancel = async () => {
        try {
            const { user } = await cancelUtility(userData)
            setUserData(user)
            console.log(user)
        } catch (e) {
            console.log(e)
        }
    }

    const loginUser = () => login(userAuth)
    const logout = () => {
        // setImgClick(false)
        return signOut(auth)
    }

    // const copied = () => toast.success('Link copied successfully')

    useEffect(() => {
        onAuthStateChanged(auth, user => {
            if (user) {
                let link = server + '/user/'
                fetch(link + user.email, {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                }).then(res => res.json()).then(data => {
                    setUserData(data)
                    console.log(data)


                    let endTrial = data.endTrial
                    let subDaysLeft = data.daysLeft
                    let today = new Date().getTime()
                    setTrialState(false)
                    if ((endTrial * 1000) >= today) {
                        setTrialState(true)
                        let diff = (endTrial * 1000) - today
                        let timeleft = diff / (1000 * 3600 * 24)
                        timeleft = Math.round(timeleft)
                        setDaysLeft(timeleft)
                    } else {
                        let diff = (subDaysLeft * 1000) - today
                        let timeleft = diff / (1000 * 3600 * 24)
                        timeleft = Math.round(timeleft)
                        setDaysLeft(timeleft)
                    }
                    setLoad(true)

                    // setIsSubscribed(data.isSubscribed)
                })
                setUserAuth(user)
            } else {
                setLoad(true)
                setUserAuth(null)
            }
        })
        //eslint-disable-next-line 
    }, [])

    const copyLink = (e) => {
        e.preventDefault();
        let link = 'https://tubelink.netlify.app/id/' + userData.generatedLink
        navigator.clipboard.writeText(link)
        notify('success', 'Link copied successfully')

    }

    return (
        <>
            <ToastContainer />
            <Header user={userAuth} logout={logout} login={loginUser} />
            {load ? <>
                {userAuth ? <>
                    {userData.isSubscribed ? <>
                        {/* pass auth to header for logout func */}
                        {/* use the syubscription use this comment to */}
                        <main className='profile'>
                            <div>
                                <p>Name</p>
                                <h1>{userData.userName}</h1>
                            </div>
                            <div>
                                <p>Youtube Channel ID</p>
                                <h1>{userData.ytID !== "" ? userData.ytID : 'Register your youtube channel'}</h1>
                            </div>
                            <div>
                                <p>Generated link</p>
                                <h1>{userData.generatedLink !== "" ? userData.generatedLink : 'No link generated'}</h1>
                                <span className="linkbtn" onClick={userData.generateLink !== "" && copyLink}>
                                    {userData.generatedLink !== "" ?
                                        'Share'
                                        :
                                        <Link to="/youtube" >Generate </Link>
                                    }
                                </span>
                            </div>
                            <div>
                                <p>Plan</p>
                                <h1>Basic</h1>
                            </div>
                            <div>
                                <p>Days left</p>
                                <h1>{daysLeft} Days {trialState && '(free trial)'}</h1>
                            </div>
                            <button onClick={cancel}>Cancel Subscription</button>
                        </main></> : <div className='not_subscribed'> Please Subscribe to continue
                        <Link to="/pricing">Subscribe</Link>
                    </div>}
                </> : <div className='not_logged_in'> Please Login to continue
                    <Link to="/" >Login</Link></div>}
            </> : 'Loading....'}
            <Footer user={userAuth} logout={logout} login={loginUser} />
        </>
    )
}

export default Profile